<template>

    <div class="my-3">
        <inertia-link :href="route('account.index')" class="">
            <i class="bi bi-arrow-left"></i>
            {{ __('Meine Organisation') }}
        </inertia-link>
    </div>

</template>


<script>
    export default {
        props: {
        },
        data() {
            return {

            }
        }
    }
</script>